import React, { useState, useEffect } from "react";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { apiFetch } from "../api_call";
import "./Dashboard.css";
import { useNavigate } from "react-router-dom";

export default function AddGrievance() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    grievance_name: "",
    start_date: "",
    end_date: "",
    comply_by: "",
    description: "",
    repeat_type: "months",
    repeat_months: 1,
    repeat_days: "",
    reminder_days: 1,
    add_escalation: false,
    escalation_email: "",
    escalation_reminder_days: "",
  });

  const FIELD_LABELS = {
    grv_act: "Grievance Name",
    grv_particular: "Grievance Name",
    grv_title: "Grievance Name",
    grv_description: "Description",
    grv_long_description: "Description",
    grv_start_date: "Start Date",
    grv_end_date: "End Date",
    grv_action_date: "Comply By",
    repeat_type: "Repeat Type",
  };

  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setErrors({});
    setSuccessMsg("");
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });

    setErrors({});
    setSuccessMsg("");
    setSuccessVisible(false);

    const newErrors = {};

    if (!formData.grievance_name) newErrors.grievance_name = "Required";
    if (!formData.start_date) newErrors.start_date = "Required";
    if (!formData.end_date) newErrors.end_date = "Required";
    if (!formData.comply_by) newErrors.comply_by = "Required";

    if (formData.add_escalation && !formData.escalation_email) {
      newErrors.escalation_email = "Required";
    }

    if (
      formData.repeat_type === "months" &&
      Number(formData.repeat_months) < 1
    ) {
      newErrors.repeat_months = "Must be ≥ 1";
    }

    if (
      formData.repeat_type === "days" &&
      Number(formData.repeat_days) < 1
    ) {
      newErrors.repeat_days = "Must be ≥ 1";
    }

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    const repeatValue =
      formData.repeat_type === "months"
        ? Number(formData.repeat_months)
        : formData.repeat_type === "days"
        ? Number(formData.repeat_days)
        : null;

    try {
      const payload = {
        grv_act: formData.grievance_name,
        grv_particular: formData.grievance_name,
        grv_title: formData.grievance_name,
        grv_description: formData.description,
        grv_long_description: formData.description,
        grv_reminder_days: Number(formData.reminder_days),
        grv_start_date: formatDate(formData.start_date),
        grv_end_date: formatDate(formData.end_date),
        grv_action_date: formatDate(formData.comply_by),
        grv_escalation_email: formData.add_escalation
          ? formData.escalation_email
          : "",
        grv_escalation_reminder_days: formData.add_escalation
          ? Number(formData.escalation_reminder_days || 0)
          : 0,
        repeat_type: formData.repeat_type,
        repeat_value: repeatValue,
      };

      const res = await apiFetch("/grievance/add/custom", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res?.error) throw res;

      setSuccessMsg(
        `✅ ${res.message} (${res.instances_created} instances created)`
      );

      setFormData({
        grievance_name: "",
        start_date: "",
        end_date: "",
        comply_by: "",
        description: "",
        repeat_type: "months",
        repeat_months: 1,
        repeat_days: "",
        reminder_days: 1,
        add_escalation: false,
        escalation_email: "",
        escalation_reminder_days: "",
      });

      setTimeout(() => {
        navigate("/manage-grievance");
      }, 1200);
    } catch (err) {
      console.error(err);
      let errorMsg = err?.error || "❌ Failed to add grievance";

      if (errorMsg.startsWith("Missing field:")) {
        const backendField = errorMsg.replace("Missing field:", "").trim();
        const friendlyName = FIELD_LABELS[backendField] || backendField;
        errorMsg = `Missing field: ${friendlyName}`;
      }

      setErrors({ api: errorMsg });
    }
  };

  useEffect(() => {
    if (successMsg) {
      setSuccessVisible(true);
      const timer = setTimeout(() => setSuccessVisible(false), 4500);
      const removeTimer = setTimeout(() => setSuccessMsg(""), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }
  }, [successMsg]);

  return (
    <div className="add-user">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="form-container">
        <h2>Add Grievance</h2>

        <div className="messages-top">
          {errors.api && <div className="login-error">{errors.api}</div>}
          {successMsg && (
            <div className={`success-msg ${!successVisible ? "fade-out" : ""}`}>
              {successMsg}
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="add-user-form">
          <label>
            Grievance Name
            <input
              name="grievance_name"
              value={formData.grievance_name}
              onChange={handleInputChange}
            />
            {errors.grievance_name && (
              <span className="error">{errors.grievance_name}</span>
            )}
          </label><label></label>

          <label>
            Start Date
            <input type="date" name="start_date" value={formData.start_date} onChange={handleInputChange} />
            {errors.start_date && <span className="error">{errors.start_date}</span>}
          </label>

          <label>
            End Date
            <input type="date" name="end_date" value={formData.end_date} onChange={handleInputChange} />
            {errors.end_date && <span className="error">{errors.end_date}</span>}
          </label>

          <label>
            Comply By (Action Date)
            <input type="date" name="comply_by" value={formData.comply_by} onChange={handleInputChange} />
            {errors.comply_by && <span className="error">{errors.comply_by}</span>}
          </label><label></label>

          <label>
            Description
            <input type="text" name="description" value={formData.description} onChange={handleInputChange} />
          </label><label></label>

          <label>
            Repeat Type
            <div>
              <input type="radio" name="repeat_type" value="months" checked={formData.repeat_type === "months"} onChange={handleInputChange} />
              <input type="number" name="repeat_months" min="1" value={formData.repeat_months} onChange={handleInputChange} /> Months
            </div>

            <div>
              <input type="radio" name="repeat_type" value="days" checked={formData.repeat_type === "days"} onChange={handleInputChange} />
              <input type="number" name="repeat_days" value={formData.repeat_days} onChange={handleInputChange} /> Days
            </div>

            <div>
              <input type="radio" name="repeat_type" value="none" checked={formData.repeat_type === "none"} onChange={handleInputChange} /> Do Not Repeat
            </div>
          </label>

          <label>
            Reminder Days
            <input type="number" name="reminder_days" min="1" value={formData.reminder_days} onChange={handleInputChange} style={{ width: "60px" }} />
          </label>

          <div>
            <input type="checkbox" name="add_escalation" checked={formData.add_escalation} onChange={handleInputChange} />
            Add Escalation <sup><i>Optional</i></sup>
          </div><label></label>

          <label>
            Escalation Email
            <input
              type="email"
              name="escalation_email"
              value={formData.escalation_email}
              onChange={handleInputChange}
              readOnly={!formData.add_escalation}
              style={{
                backgroundColor: formData.add_escalation ? "white" : "#f0f0f0",
                cursor: formData.add_escalation ? "text" : "not-allowed",
              }}
            />
            {errors.escalation_email && <span className="error">{errors.escalation_email}</span>}
          </label>

          <label>
            Reminder of Escalation Email
            <input
              type="number"
              name="escalation_reminder_days"
              value={formData.escalation_reminder_days}
              onChange={handleInputChange}
              readOnly={!formData.add_escalation}
              style={{
                backgroundColor: formData.add_escalation ? "white" : "#f0f0f0",
                cursor: formData.add_escalation ? "text" : "not-allowed",
                width: "60px",
              }}
            />
          </label>

          <button type="submit" className="submit-btn">
            Create Grievance
          </button>
        </form>
      </div>
    </div>
  );
}